export const GET_TYPE_PRIORITY = 'GET_TYPE_PRIORITY'
export const GET_TYPE_PRIORITY_EXITO = 'GET_TYPE_PRIORITY_EXITO'
export const GET_TYPE_PRIORITY_ERROR = 'GET_TYPE_PRIORITY_ERROR'
